import { RouteConfig, Route } from 'vue-router';
import { RouterPath } from '../shared/enums';
import { Role } from '../shared/enums/role.enum';

import store from '../store';

const callbackPermission = (next) => {
    const isB2B = store.getters['auth/isB2B'];
    if (isB2B) {
        next({ path: RouterPath.HOME, replace: true });
    } else {
        next();
    }
};

export default (): Array < RouteConfig > => {
    return [{
            path: RouterPath.PAGE_USERS,
            meta: {role: Role.PERMISSION},
            component: () => import ('./components/pages/page-users').then(m => m.default),
            beforeEnter(to, from, next) {
                callbackPermission(next);
            }
        },
        {
            path: RouterPath.PAGE_REGISTER_USER,
            meta: {role: Role.PERMISSION},
            component: () => import('./components/pages/page-register-user').then(m => m.default),
            beforeEnter(to, from, next) {
                callbackPermission(next);
            }
        }
    ];
};
